var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBordLanguage = function SvgBordLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.17 17.313C47.163 20.063 49 23.814 49 27.95c0 4.79-2.473 9.077-6.345 11.881a9.572 9.572 0 0 0-.068 1.059c0 2.565 1.495 4.812 3.783 6.055v.992c-4.244-.109-8.145-.828-11.821-4.876-.87.119-1.759.185-2.669.185-3.931 0-7.548-1.189-10.442-3.175 5.954-.021 11.576-2.15 15.839-6 2.141-1.944 3.842-4.213 5.035-6.766a20.108 20.108 0 0 0 1.908-8.564c0-.48-.02-.959-.05-1.428zM19.907 2c10.992 0 19.907 7.726 19.907 17.257 0 9.54-8.915 17.267-19.907 17.267-1.054 0-2.087-.074-3.102-.211-4.276 4.56-9.21 5.383-14.145 5.5v-1.119c2.66-1.393 4.807-3.927 4.807-6.829 0-.412-.028-.803-.088-1.193C2.877 29.506 0 24.672 0 19.257 0 9.727 8.914 2 19.906 2z"
  })));
};

export default SvgBordLanguage;